export default  {
    component: 'breaker_param',
    name: 'breaker_param',
    fields: [
        {
            param: 'plant_id',
            type: 'number',
            required: true,
            identifier: true,
            hidden: true
          },
          {
            name: 'Role',
            param: 'role',
            type: 'text',
            description: `We need to add 3 types of roles:
            - **user** 
            - **admin** 
            - **super-admin**`
          },
          {
            name: 'Module',
            param: 'module',
            type: 'text',
            description: `Their are 2 options for module:
            - **other-sensor** 
            - **analytics**
            We need to add module for each roles`
          },
          {
            name: 'Parameters',
            param: 'parameters',
            type: 'text',
            description: `Option for parameters are displayed as follows::
            - **other-sensor** [Parameter Options : breaker_on, breaker_off, breaker_trip, local, remote, test]
            - **analytics** [Parameter Options : breaker_on, breaker_off, breaker_trip, local, remote, test]`
          }
    ]
  }
